import {
    FETCH_ROUTE_REQUEST,
    FETCH_ROUTE_SUCCESS,
    FETCH_ROUTE_FAILURE,
    ADD_ROUTE_REQUEST,
    ADD_ROUTE_SUCCESS,
    ADD_ROUTE_FAILURE,
    UPDATE_ROUTE_REQUEST,
    UPDATE_ROUTE_SUCCESS,
    UPDATE_ROUTE_FAILURE,
    DELETE_ROUTE_REQUEST,
    DELETE_ROUTE_SUCCESS,
    DELETE_ROUTE_FAILURE,
    ROUTE_FORM_ERROR,
    ROUTE_FORM_SUCCESS,
    SET_ROUTE_EDIT,
    CLEAR_ROUTE_EDIT,
  } from '../../../../types/masters/route/route/routeMasterTypes';
  
  const initialState = {
    list: [],
    loading: false,
    error: null,
    editingRoute: null,
  };
  
  const routeMasterReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ROUTE_REQUEST:
      case ADD_ROUTE_REQUEST:
      case UPDATE_ROUTE_REQUEST:
      case DELETE_ROUTE_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_ROUTE_SUCCESS:
        return { ...state, loading: false, list: action.payload, error: null };
      case ADD_ROUTE_SUCCESS:
      case UPDATE_ROUTE_SUCCESS:
      case DELETE_ROUTE_SUCCESS:
        return { ...state, loading: false, error: null };
      case FETCH_ROUTE_FAILURE:
      case ADD_ROUTE_FAILURE:
      case UPDATE_ROUTE_FAILURE:
      case DELETE_ROUTE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_ROUTE_EDIT:
        return { ...state, editingRoute: action.payload };
      case CLEAR_ROUTE_EDIT:
        return { ...state, editingRoute: null };
      default:
        return state;
    }
  };
  
  export default routeMasterReducer;